import { useState, useEffect, useCallback } from "react";

export default function useTheme() {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("ai-chat-theme") || "dark";
    } catch {
      return "dark";
    }
  });

  useEffect(() => {
    const el = document.querySelector(".ai-layout");
    if (el) {
      if (theme === "light") {
        el.classList.add("light-theme");
      } else {
        el.classList.remove("light-theme");
      }
    }
    try {
      localStorage.setItem("ai-chat-theme", theme);
    } catch {
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  }, []);

  return { theme, toggleTheme };
}
